import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { useContext, type FC } from "react";
import { useTranslation } from "react-i18next";

import { ExpandedTable } from "@ryde/controls";
import { getBookingCalendarCellId } from "@ryde/shared";

import { BulkPreviewStepConflictsContext } from "../bulk-preview-step-conflicts.context";
import { RejectedBookingExpanded } from "./rejected-bookings-expanded";
import { RejectedBookingsOverlappingRow } from "./rejected-bookings-overlapping-row";

interface IRejectedBookingsOverlappingTableProps {
  /**
   * The gap checks are a soft validation on the bulk date/time panel: each row names its booking
   * and carries its own approve control.
   */
  isApprovable?: boolean;
}

export const RejectedBookingsOverlappingTable: FC<
  IRejectedBookingsOverlappingTableProps
> = ({ isApprovable }) => {
  const { conflicts, isPreview } = useContext(BulkPreviewStepConflictsContext);
  const { t } = useTranslation();

  return (
    <RejectedBookingExpanded>
      <ExpandedTable dataE2E="rejected-bookings-overlapping">
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>
                {t(
                  isApprovable
                    ? "booking.bulk.bookingId"
                    : "booking.bulk.passengerId",
                )}
              </TableCell>
              <TableCell>{t("booking.bulk.passengerFullName")}</TableCell>
              <TableCell>{t("booking.bulk.overlapWith")}</TableCell>
              <TableCell>{t("booking.bulk.date")}</TableCell>
              {isApprovable && isPreview && <TableCell />}
            </TableRow>
          </TableHead>
          <TableBody>
            {conflicts?.map((conflictRow, i) => (
              <RejectedBookingsOverlappingRow
                key={`${getBookingCalendarCellId(conflictRow.passengerId as number, conflictRow.date)}_${i}`}
                conflictRow={conflictRow}
                isApprovable={isApprovable}
              />
            ))}
          </TableBody>
        </Table>
      </ExpandedTable>
    </RejectedBookingExpanded>
  );
};
